var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTvBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 543,
    height: 229,
    viewBox: "0 0 543 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_4377_19493)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4377_19493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.332 1.21094L160.567 81.1127L188.651 4.06916L182.895 82.8225L261.759 12.5005L204.301 86.1564L329.991 26.0821L223.712 90.9473L389.925 44.1331L240.155 96.9548L438.556 65.7482L252.804 103.878L473.445 89.8436L261.026 111.369L492.842 115.211L264.408 119.053L495.776 140.578L262.781 126.544L482.099 164.674L256.226 133.467L452.496 186.289L245.072 139.475L408.453 204.34L229.879 144.265L352.177 217.921L211.407 147.599L286.491 226.353L190.584 149.309L214.689 229.211L168.454 149.309L140.37 226.353L146.126 147.599L67.2617 217.921L124.719 144.265L-0.970174 204.34L105.308 139.475L-60.9042 186.289L88.866 133.467L-109.535 164.674L76.2168 126.544L-144.424 140.578L67.9949 119.053L-163.822 115.211L64.6128 111.369L-166.755 89.8436L66.2399 103.878L-153.078 65.7482L72.7947 96.9548L-123.476 44.1331L83.9485 90.9473L-79.4323 26.0821L99.1421 86.1564L-23.1567 12.5005L117.613 82.8225L42.5293 4.06916L138.436 81.1127L114.332 1.21094Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4377_19493",
    x: -191.115,
    y: -23.1491,
    width: 711.251,
    height: 276.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.18,
    result: "effect1_foregroundBlur_4377_19493"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4377_19493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 543,
    height: 228,
    fill: "white",
    transform: "matrix(1 1.74846e-07 1.74846e-07 -1 0 228.469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvBackground);
export default __webpack_public_path__ + "static/media/tvBackground.15852784cba9d3b0c720e7c1fcec0473.svg";
export { ForwardRef as ReactComponent };